import {Evt, EvtNameSpace, EvtType} from "../util/event-manager";
import {LoggedInUser} from "./auth-type-def";
import {LoginType, SocialType} from "../../_genApi/gameDeploy";
import {AUTH_TOKEN_KEY, AUTH_USER_KEY} from "./auth-api";
import { getDeviceId } from '../device-id';

export default abstract class AbstractAuthModule {
  loginType: LoginType;

  setCurrentUser = (whatever: LoggedInUser | undefined) => {
    console.log('forgot to wire me ?');
  }

  getCurrentUser = (): LoggedInUser | undefined => {
    console.log('forgot to wire me ?');
    return undefined
  }

  readCachedUserInfo(): LoggedInUser | undefined {
    try {
      const token = localStorage.getItem(AUTH_TOKEN_KEY);
      const userJson = localStorage.getItem(AUTH_USER_KEY);
      if (!token || !userJson) return undefined;

      const user = JSON.parse(userJson);
      // loginType stored by web-listing; Studio doesn't write it, default to SOCIAL
      const loginType = user.loginType || LoginType.SOCIAL;
      if (this.loginType !== loginType) return undefined;

      return {
        loginType,
        socialType: user.socialType || user.social || '',
        zpsToken: token,
        zpsUserId: user.uid,
        zpsUsername: user.username,
        name: user.fullName || user.username || '',
        avatar: user.avatar || '',
      };
    } catch {
      return undefined;
    }
  }

  async onLoggedIn() {
    const _currentUser = this.getCurrentUser();

    // Persist BEFORE dispatching so listeners that read localStorage see the new token.
    if (_currentUser?.zpsToken) {
      localStorage.setItem(AUTH_TOKEN_KEY, _currentUser.zpsToken);
      localStorage.setItem(AUTH_USER_KEY, JSON.stringify({
        uid: _currentUser.zpsUserId,
        username: _currentUser.zpsUsername,
        social: _currentUser.socialType || '',
        fullName: _currentUser.name || '',
        avatar: _currentUser.avatar || '',
        // Extra fields for web-listing (Studio ignores them)
        loginType: _currentUser.loginType,
        socialType: _currentUser.socialType,
      }));
    }

    const userName = _currentUser.zpsUsername || _currentUser.name || '';
    const userId = getDeviceId();
    if (userName && userId) {
      const isHttps = window.location.protocol === 'https:';
      const attrs = `Path=/; SameSite=Lax${isHttps ? '; Secure' : ''}`;
      document.cookie = `username=${encodeURIComponent(userName)}; ${attrs}`;
      document.cookie = `userId=${encodeURIComponent(userId)}; ${attrs}`;
    }

    Evt.dispatch(EvtNameSpace.Auth, EvtType.LoggedIn, {user: _currentUser});
  }

  logout() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
    document.cookie = 'username=; Max-Age=0; Path=/';
    document.cookie = 'userId=; Max-Age=0; Path=/';
    this.setCurrentUser(undefined);
    Evt.dispatch(EvtNameSpace.Auth, EvtType.LoggedOut);
  }

  abstract start();
  abstract userReLogin(socialType: SocialType);
  abstract getLoginToken()
  abstract hadLoggedIn();
  abstract loadToken(socialType: SocialType, authenCode: string);
  abstract getUsername();
}
